import { fromJS } from 'immutable';
import { QUOTED } from 'pu-data/QuoteSteps';

const state = {
  // loading: null,
  // parameters: null,
  // parameters_changed: null,
  // suppliers: null,
  quote: Spree.quote,
  // quote_step: QUOTED,
};

if (Spree.quote_parameters) {
  state.parameters = Spree.quote_parameters;
  state.quoteStep = QUOTED;
}

export default fromJS(state);
